import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import fetch from './../../fetch';
import { baseUrl, customHeaders, indianProjectsBaseURL, uaeProjectsBaseURL } from '../../../../Containers/Config/index.js';

import { GET_COUPON_SERVICE, GET_COUPON_SERVICE_SUCCESS, GET_COUPON_SERVICE_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant';

function* getCouponService({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/admin/services`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        pageIndex: 0,
        pageSize: 100,
        ...payload?.urlParam,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_COUPON_SERVICE_SUCCESS,
        payload: response?.data?.results,
      });
    } else {
      yield put({
        type: GET_COUPON_SERVICE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_COUPON_SERVICE_ERROR, payload: error });
  }
}

export function* watchGetCouponService() {
  yield takeEvery(GET_COUPON_SERVICE, getCouponService);
}

function* getCouponServiceSaga() {
  yield all([fork(watchGetCouponService)]);
}

export default getCouponServiceSaga;
